import { makeStyles } from '@fluentui/react-components';

export const useRoomTypeBarChartStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
});
